import React from 'react';

import section3Styles from './section3.module.scss';

function renderSection3(props) {
  return (
    <section className={section3Styles.section3} data-aos="fade-left">
      <img className={section3Styles.image2} src={'/assets/51a3af4f95b0601c4aff9a7b5d0446e1.png'} alt="alt text" />
    </section>
  );
}

export default renderSection3;
